import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../Common/Alert";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";
import ReactDataTable from "../../Common/ReactDataTable";
const List = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [onTest, setOnTest] = useState(false);
  const [role, setRole] = useState("");

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [statusValue, setStatusValue] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateAlert, setUpdateAlert] = useState(null);

  // Multiple selection states
  const [selectedRows, setSelectedRows] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkStatusValue, setBulkStatusValue] = useState("");
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);
  const [bulkUpdateAlert, setBulkUpdateAlert] = useState(null);
  const [selectAll, setSelectAll] = useState(false);

  // Handle individual row selection
  const handleRowSelect = (rowData) => {
    if (!rowData || !rowData.id) return; // Add safety check

    setSelectedRows((prev) => {
      const isSelected = prev.some((row) => row.id === rowData.id);
      if (isSelected) {
        return prev.filter((row) => row.id !== rowData.id);
      } else {
        return [...prev, rowData];
      }
    });
  };

  // Handle select all rows - with null check
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      // Filter out any null/undefined items
      setSelectedRows([...receiveData].filter((item) => item && item.id));
    }
    setSelectAll(!selectAll);
  };

  // Check if a row is selected - with null check
  const isRowSelected = (rowData) => {
    if (!rowData || !rowData.id) return false; // Add safety check
    return selectedRows.some((row) => row.id === rowData.id);
  };

  const fetchData = () => {
    Http.get("/staff-type-check").then((res) => {
      setRole(res.data);
      if (res.data == "sample") {
        setOnTest(true);
      }
    });

    Http.get("/planning-image").then((res) => {
      setReceiveData(res.data);
      document.getElementById("app-title").innerText = `(0) Artisan ERP`;
    });
  };

  console.log(onTest, "onTest");
  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const markAsRead = (id) => {
    Http.get("/notifications/" + id + "/mark-as-read")
      .then((res) => {
        Swal.fire("Mark As Read!", "Mark As Read", "success");
        Http.get("/notifications").then((res) => {
          setReceiveData(res.data);
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  const deleteImage = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.get("/planning-image-delete/" + id)
          .then((res) => {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            fetchData();
            navigate("/planning-image-upload");
          })
          .catch((error) => {
            Swal.fire(
              "Error!",
              "An error occurred while deleting the image.",
              "error"
            );
          });
      }
    });
  };
  const url = "https://artisan.projectsample.info/backend/public/";

  const imageBodyTemplate = (rowData) => {
    return (
      <img
        src={rowData.path ? url + rowData.path : "placeholder-image.webp"}
        alt={rowData.name}
        style={{ width: "80px", height: "80px" }}
      />
    );
  };

  function formatStatusText(text) {
  if (!text) return "";

  // Replace underscore with space
  let formatted = text.replace(/_/g, " ");

  // Make first word uppercase, keep the rest lowercase
  let parts = formatted.split(" ");

  return parts.join(" ");
}

  const cols = [
    {
      header: "Image",
      field: imageBodyTemplate,
      style: { width: "100px" },
    },
    { field: "code", header: "Code" },
    // { field: "image", header: "Image", render: (item) => Image(item.path) },
    { field: "decoration_name", header: "Decoration Name" },
    { field: "name", header: "Image Name" },
    { field: (rowData)=>{
      return formatStatusText(formatStatusText(rowData.status));
    }, header: " Status " },
    {
      field: (item) => (
        <div>
          {/* <Link
            to={`/edit-planning-image-upload/${item.id}`}
            className="btn btn-primary btn-sm me-2"
            title="Edit planning image upload"
          >
            <i className="fa fa-edit"></i>
          </Link> */}
          {item.status == "on_test" && (
            <button
              className="btn btn-info btn-sm me-1"
              onClick={() => handleStatusUpdate(item)}
              title="Update Status"
            >
              <i className="fa fa-edit"></i>
            </button>
          )}

          <Link
            onClick={() => deleteImage(item.id)}
            className="btn btn-danger btn-sm"
            title="Delete planning image upload"
          >
            <i className="fa fa-trash"></i>
          </Link>
        </div>
      ),
      header: "Action",
    },
  ];

  const handleStatusSubmit = async (e) => {
    e.preventDefault();
    if (!selectedShape) return;

    setIsUpdating(true);
    try {
      const response = await Http.put(`/planning-image/${selectedShape.id}`, {
        status: statusValue,
      });

      if (response.status === 200) {
        setUpdateAlert({
          type: "success",
          message: "Status updated successfully!",
        });

        // Update the local data
        setReceiveData((prevData) =>
          prevData.map((item) =>
            item.id === selectedShape.id
              ? { ...item, status: statusValue }
              : item
          )
        );

        // Close modal after a short delay
        setTimeout(() => {
          handleModalClose();
        }, 1500);
      }
    } catch (error) {
      console.error("Update error:", error);
      setUpdateAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to update status",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  // Bulk status update
  const handleBulkStatusSubmit = async (e) => {
    e.preventDefault();
    if (selectedRows.length === 0) return;
    setIsBulkUpdating(true);
    try {
      const response = await Http.post(`/planning-image/bulk-update`, {
        ids: selectedRows.map((row) => row.id),
        status: bulkStatusValue,
      });

      if (response.status === 200) {
        setBulkUpdateAlert({
          type: "success",
          message: `Status updated for ${selectedRows.length} Decoration Design(s)!`,
        });

        // Update local data
        setReceiveData((prevData) =>
          prevData.map((item) =>
            selectedRows.some((selected) => selected.id === item.id)
              ? { ...item, status: bulkStatusValue }
              : item
          )
        );

        // Clear selection after successful update
        setTimeout(() => {
          handleBulkModalClose();
          setSelectedRows([]);
          setSelectAll(false);
        }, 1500);
      }
    } catch (error) {
      console.error("Bulk update error:", error);
      setBulkUpdateAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to update status",
      });
    } finally {
      setIsBulkUpdating(false);
    }
  };
  // Handle modal open
  const handleStatusUpdate = (item) => {
    setSelectedShape(item);
    setStatusValue(item.status || "");
    setShowModal(true);
    setUpdateAlert(null);
  };
  // Handle modal close
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedShape(null);
    setStatusValue("");
    setUpdateAlert(null);
  };

  // Bulk modal handlers
  const handleBulkStatusUpdate = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one Decoration Designs to update.");
      return;
    }
    setBulkStatusValue("");
    setShowBulkModal(true);
    setBulkUpdateAlert(null);
  };

  const handleBulkModalClose = () => {
    setShowBulkModal(false);
    setBulkStatusValue("");
    setBulkUpdateAlert(null);
  };

  return (
    <>
      <IsLogin />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Image Upload</h5>
            <Link
              to="/create-planning-image-upload"
              className="btn btn-primary"
              title="Create planning image upload"
            >
              <i className="fa fa-plus-square mg-r-6"></i>
              Create
            </Link>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            {selectedRows.length > 0 && (
              <div className="alert alert-info mb-3">
                <strong>{selectedRows.length}</strong> Decoration Design(s)
                selected.
                <button
                  className="btn btn-sm btn-outline-info ms-2"
                  onClick={handleBulkStatusUpdate}
                >
                  Bulk Update
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary ms-2"
                  onClick={() => {
                    setSelectedRows([]);
                    setSelectAll(false);
                  }}
                >
                  Clear Selection
                </button>
              </div>
            )}

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                // imageBodyTemplate={imageBodyTemplate}
                cols={cols}
                test={onTest}
                receiveData={receiveData}
              />
            </div>

            {/* Status Update Modal */}
            {showModal && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        Update Status - {selectedShape?.name}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleModalClose}
                        disabled={isUpdating}
                      ></button>
                    </div>
                    <form onSubmit={handleStatusSubmit}>
                      <div className="modal-body">
                        {updateAlert && (
                          <div
                            className={`alert alert-${
                              updateAlert.type === "success"
                                ? "success"
                                : "danger"
                            }`}
                          >
                            {updateAlert.message}
                          </div>
                        )}
                        <div className="mb-3">
                          <label htmlFor="statusInput" className="form-label">
                            Status
                          </label>
                          <select
                            id="statusInput"
                            className="form-select"
                            value={statusValue}
                            onChange={(e) => setStatusValue(e.target.value)}
                            required
                            disabled={isUpdating}
                          >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Decoration Designs Code:
                          </label>
                          <p className="form-control-plaintext">
                            {selectedShape?.code}
                          </p>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleModalClose}
                          disabled={isUpdating}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isUpdating || !statusValue}
                        >
                          {isUpdating ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Updating...
                            </>
                          ) : (
                            "Update Status"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}

            {/* Bulk Status Update Modal */}
            {showBulkModal && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Bulk Update Status</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleBulkModalClose}
                        disabled={isBulkUpdating}
                      ></button>
                    </div>
                    <form onSubmit={handleBulkStatusSubmit}>
                      <div className="modal-body">
                        {bulkUpdateAlert && (
                          <div
                            className={`alert alert-${
                              bulkUpdateAlert.type === "success"
                                ? "success"
                                : "danger"
                            }`}
                          >
                            {bulkUpdateAlert.message}
                          </div>
                        )}
                        <div className="mb-3">
                          <p className="text-muted">
                            Updating status for{" "}
                            <strong>{selectedRows.length}</strong> selected
                            Decoration Design(s)
                          </p>
                        </div>
                        <div className="mb-3">
                          <label
                            htmlFor="bulkStatusInput"
                            className="form-label"
                          >
                            Status
                          </label>
                          <select
                            id="bulkStatusInput"
                            className="form-select"
                            value={bulkStatusValue}
                            onChange={(e) => setBulkStatusValue(e.target.value)}
                            required
                            disabled={isBulkUpdating}
                          >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="on_test">On Test</option>
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Selected Decoration Designs:
                          </label>
                          <div className="small text-muted">
                            {selectedRows
                              .slice(0, 5)
                              .map((row) => row.name)
                              .join(", ")}
                            {selectedRows.length > 5 &&
                              ` and ${selectedRows.length - 5} more...`}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleBulkModalClose}
                          disabled={isBulkUpdating}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isBulkUpdating || !bulkStatusValue}
                        >
                          {isBulkUpdating ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Updating {selectedRows.length} items...
                            </>
                          ) : (
                            `Update ${selectedRows.length} Items`
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default List;
